function toString(value: any): string {
  if (typeof value === 'string') {
    return value;
  }

  return JSON.stringify(value);
}

export function sortAsc<T>(a: T, b: T, selector: (value: T) => any): number {
  if (toString(selector(a)).trim() < toString(selector(b)).trim()) {
    return -1;
  }

  if (toString(selector(a)).trim() > toString(selector(b)).trim()) {
    return 1;
  }

  return 0;
}

export function sortDesc<T>(a: T, b: T, selector: (value: T) => any): number {
  if (toString(selector(a)).trim() < toString(selector(b)).trim()) {
    return 1;
  }

  if (toString(selector(a)).trim() > toString(selector(b)).trim()) {
    return -1;
  }

  return 0;
}

/*
  Can be used with the javascript .sort() function to sort by multiple fields:
    e.g.
      myArray.sort(fieldSorter(['-isFavorite', 'openTaskCount']))

    a - in front of the fieldname sorts the field descending instead of ascending
*/
export const fieldSorter = (fields: any) => (a: any, b: any) =>
  fields
    .map((o: any) => {
      let dir = 1;
      if (o[0] === '-') {
        dir = -1;
        o = o.substring(1);
      }
      if (typeof a[o] === 'string') {
        return a[o].toLowerCase() > b[o].toLowerCase() ? dir : a[o].toLowerCase() < b[o].toLowerCase() ? -dir : 0;
      }
      return a[o] > b[o] ? dir : a[o] < b[o] ? -dir : 0;
    })
    .reduce((p: any, n: any) => (p ? p : n), 0);
